import { HttpClient } from './HttpClient.js';

export const DebtorFieldService = {
    /**
     * Obtiene la configuración de campos del componente "Datos del deudor"
     * para el tenant (despacho) del usuario autenticado.
     * @returns {Promise<{error:boolean,msg:string,response:{profile:string,tabs:Object,fields:Array,headers:Array,keys:Array}}>}
     */
    getFields: async function () {
        return await HttpClient.get('/debtor-fields').then((response) => response);
    },

    /**
     * Lista los perfiles por tenant, el catálogo de campos fuente y los tenants disponibles (solo admins).
     */
    getProfiles: async function () {
        return await HttpClient.get('/debtor-fields/config').then((response) => response);
    },

    /**
     * Obtiene los campos editables de un perfil, agrupados por pestaña (solo admins).
     */
    getProfileFields: async function (profileId) {
        return await HttpClient.get(`/debtor-fields/config/${profileId}`).then((response) => response);
    },

    /**
     * Persiste el set de campos (orden, visibilidad y etiquetas) de una pestaña (solo admins).
     */
    saveProfileFields: async function (profileId, tab, fields) {
        return await HttpClient.putJSON(`/debtor-fields/config/${profileId}`, {
            tab,
            fields,
        }).then((response) => response);
    },
};